import { useMatchesData } from './use-matches-data'

export function useImpersonatedSellerId() {
  const data = useMatchesData('routes/__shop')

  if (!data || typeof data.iSellerId !== 'string') {
    return undefined
  }

  return data.iSellerId
}
